"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const SystemsMenuToggle_1 = __importDefault(require("../../atoms/SystemsMenuToggle"));
const hooks_1 = require("../../hooks");
const SystemMenuList_1 = require("../../molecules/SystemMenuList");
const selectors_1 = require("../../store/selectors");
const deviceBreakpointSize = 899;
function SystemsPanel({ onClick, isOpen, setIsExpandSystems, resetButtonPressed, setResetButtonPressed, }) {
    const systems = (0, hooks_1.useSelector)(selectors_1.getSystemStates);
    const [isExpand, setIsExpand] = (0, react_1.useState)(false);
    const isLower = (0, ui_1.useScreenBreakpoint)(deviceBreakpointSize);
    const onMinimise = (state) => {
        setIsExpand(state);
        setIsExpandSystems(state);
    };
    const renderSystemsList = () => isOpen || isLower ? ((0, jsx_runtime_1.jsx)(SystemMenuList_1.SystemMenuList, { resetButtonPressed: resetButtonPressed, setResetButtonPressed: setResetButtonPressed, onOpen: onMinimise, "data-e2e": 'SystemsPanel_SystemMenuList' })) : null;
    const renderHeader = () => isExpand || isLower ? null : ((0, jsx_runtime_1.jsx)(SystemsMenuToggle_1.default, { onClick: onClick, isOpen: isOpen, "data-e2e": 'SystemsPanel_SystemsMenuToggle' }));
    (0, react_1.useEffect)(() => {
        if (systems.length === 1) {
            setIsExpand(true);
        }
    }, [systems]);
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'SystemsPanel_Container', children: [renderHeader(), renderSystemsList()] }));
}
exports.default = SystemsPanel;
const Container = styled_components_1.default.div `
  max-height: calc(100vh - 24px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
